<template>
    <dv-border-box-12>
        <div id="assess-chart" class="wh1"></div>
    </dv-border-box-12>
</template>

<script>

import * as echarts from 'echarts'

export default {
  name: 'assessChart',
  data () {
    return {
      chartData: []
    }
  },
  created () {
    let year = new Date().getFullYear()
    this.$api.getAssess(year).then((res) => {
      if (!res.ok) return
      this.chartData = res.data
      console.debug('data', JSON.stringify(this.chartData))
      this.drawLine()
    }).catch((error) => {
      console.log(error)
    })
    // this.chartData = [{ 'name': '达标', 'value': 5 }, { 'name': '基本达标', 'value': 1 }, { 'name': '不达标', 'value': 0 }, { 'name': '整改达标', 'value': 2 }, { 'name': '整改不达标', 'value': 2 }]
    // this.drawLine()
  },
  methods: {
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(
        document.getElementById('assess-chart')
      )
      // 绘制图表
      myChart.setOption({
        color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de'],
        backgroundColor: 'transparent',
        title: {
          text: '考核结果',
          // textAlign: "center",
          textStyle: {
            color: '#FFFFFF',
            fontSize: '16px'
          }
        },
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            // name: '考核评分',
            type: 'pie',
            radius: '72%',
            data: this.chartData,
            label: {
              textStyle: {
                color: 'rgba(255,255,255,.5)',
                fontSize: 12,
                fontWeight: 'bolder'
              }
            }
          }
        ]
      })
    }
  }
}
</script>

<style lang="less"></style>
